import React from "react";
import StarRating from "./StarRating";
import { ProductCardAction } from "./ProductCardAction";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { AddTocartButton } from "./AddTocartButton";
import { useSelector } from "react-redux";
import { formatSoldCount } from "../service";


export default function ProductCard3({ product, size = "default", showDes = false }) {
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  return (
    <div className={`w-full xl:p-4 flex gap-2 justify-start items-start bg-white group/card ${size == "large" ? "h-auto min-h-52" : "h-auto"} `}>
      <Link to={`/products/${product?._id}?ref=${userInfo?.address ?? ""}`} className={`relative border rounded-xl shadow-sm overflow-hidden  ${size == "large" ? "w-[250px] h-[250px]" : "w-[120px] h-[120px]"}  `}>
        <img
          src={product?.image?.["url"]}
          alt={product?.name}
          className="w-full h-full object-cover"
        />
        <img
          src={product?.arrImage?.[1]?.["url"] ? product?.arrImage?.[1]?.["url"] : product?.image?.["url"]}
          alt={product?.name}
          className="w-full h-full  object-cover absolute top-0 left-0 z-40 opacity-0 group-hover/card:opacity-100 transition-opacity duration-300"
        />
        {product?.discount > 0 && (
          <span className="absolute top-2 left-2 bg-red-500 text-white text-[10px] px-[5px] py-[1px] rounded z-50">
            Sale
          </span>
        )}

        <ProductCardAction product={product} />
      </Link>

      <div className={`flex flex-col gap-1 items-start ${size == "large" ? "w-[calc(100%-250px)]" : "w-[calc(100%-120px)]"} `}>
        <Link to={`/products/${product?._id}?ref=${userInfo?.address ?? ""}`}>
          <h3 className="text-sm font-semibold line-clamp-1 text-left hover:text-[--color-button-3] transition-all duration-150   ">{product?.name}</h3></Link>
        {showDes && <p className={`text-sm  ${size == "large" ? " line-clamp-4" : " line-clamp-2"} text-left hover:text-[--color-button-3] transition-all duration-150  `}>{product?.description}</p>}
        <div className="flex items-center gap-2">
          <StarRating rate={product?.rating ?? 0} />

          <span className="text-xs text-gray-400 ">({product?.numReviews ?? 0})</span>
        </div>


        <div className="flex items-center gap-2 flex-wrap w-full">
          <span className="flex w-1/3 xl:w-auto text-sm xl:text-base font-bold text-red-600 gap-2">
            <img src="/images/logoToken.png" style={{ width: 20 }} /> {product?.price?.toFixed(2)}
          </span>
          {product?.oldPrice && <span className="flex  w-1/3 xl:w-auto text-sm line-through text-gray-400 gap-2">
            <img src="/images/logoToken.png" style={{ width: 20 }} /> {product?.oldPrice?.toFixed(2)}
          </span>}
          {product?.discount && <span className="flex justify-center  xl:w-auto bg-green-600 text-white text-xs px-[5px] py-[1px] rounded-md">
            {product?.discount}%
          </span>}
          <span className="okkk3rd">Đã bán {formatSoldCount(product?.sold)}</span>

        </div>


        <AddTocartButton product={product} />
      </div>


    </div>
  );
}
